import ReactOnRails from 'react-on-rails';
import eyeIcon from '../images/eye-regular.svg';
import eyeSlashIcon from '../images/eye-slash-regular.svg';

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

require('@rails/ujs').start(); // eslint-disable-line
require('@rails/activestorage').start(); // eslint-disable-line
import 'bootstrap';
import { initHubspotChat } from '../src/javascript/global/init_hubspot';
import GlobalNav from '../src/javascript/components/shared/global_nav';
import RequiredAcknowledgementEvents from '../src/javascript/components/required_acknowledgement_events/dialog';

// eslint-disable-next-line
const images = require.context('../images', true);
// eslint-disable-next-line
const imagePath = (name) => images(name, true);

function initPasswordField(fieldId) {
  const passwordField = document.querySelector(fieldId);
  if (!passwordField) return;

  const passwordToggle = passwordField.nextElementSibling;

  if (passwordField && passwordToggle) {
    passwordToggle.addEventListener('click', () => {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        passwordToggle.innerHTML = `<img src="${eyeSlashIcon}" alt="Hide password">`;
      } else {
        passwordField.type = 'password';
        passwordToggle.innerHTML = `<img src="${eyeIcon}" alt="Show password">`;
      }
    });
  }
}

function registerReactComponents() {
  ReactOnRails.register({
    GlobalNav,
    RequiredAcknowledgementEvents,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initPasswordField('#password-field');
  initPasswordField('#password-confirmation-field');
  initHubspotChat();
  registerReactComponents();
});
